import { Component, Input } from '@angular/core';

import { Usuario } from '../../usuario';

@Component({
    selector: 'sgt-usuario-permissao-pedido',
    templateUrl: './usuario-permissao-pedido.component.html',
    styleUrls: ['./usuario-permissao-pedido.component.less']
})
export class UsuarioPermissaoPedidoComponent {
    @Input() entity: Usuario;
    @Input() isPerfilRepresentante: boolean;

    /** Verifica se possui alguma opção para selecionar */
    possuiAlgumaOpcao(): boolean {
        // Usuários de perfil representante por enquanto não possui
        if (this.isPerfilRepresentante) {
            return false;
        }

        return true;
    }
}
